import {css} from "@emotion/react";


export const root = css`
    display: flex;
    flex-direction: column;
    flex: 1;
    background-color: #F4F6FA;
    overflow: hidden;
`;

export const tabs = css`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    height: 62px;
    width: 100%;
    border-bottom: 0.5px solid #C5CACE;
`;

export const content = css`
    display: grid;
    flex: 1;
    flex-direction: column;
    width: 100%;
    background-color: white;
    padding: 32px;
    color: #2B2B2B;
    grid-row-gap: 24px;
    grid-auto-rows: min-content;
`;

export const contentWrapper = css` 
    overflow: auto;
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
`;